// Single source of truth for SA location hierarchy — used by VendorDashboard.js and Vendors.js

export const CITY_AREAS = {
  'Pretoria / Tshwane': {
    areas: [
      'Pretoria', 'Centurion', 'Pretoria North', 'Pretoria East',
      'Mamelodi', 'Atteridgeville', 'Hammanskraal', 'Mabopane',
      'Soshanguve', 'Ga-Rankuwa', 'Arcadia', 'Sunnyside',
      'Hatfield', 'Brooklyn', 'Menlyn', 'Waterkloof',
      'Wonderboom', 'Silverton', 'Lynnwood', 'Faerie Glen',
      'Garsfontein', 'Moreleta Park', 'Waverley', 'Montana',
      'Eersterust', 'Winterveld', 'Laudium', 'Olievenhoutbosch',
      'Cullinan', 'Bronkhorstspruit'
    ],
    province: 'Gauteng'
  },
  'Johannesburg': {
    areas: [
      'Johannesburg', 'Sandton', 'Soweto', 'Midrand', 'Randburg',
      'Roodepoort', 'Fourways', 'Rosebank', 'Alexandra', 'Bedfordview',
      'Bryanston', 'Randfontein', 'Lenasia', 'Northriding',
      'Diepsloot', 'Orange Farm', 'Houghton', 'Parktown', 'Melville',
      'Braamfontein', 'Honeydew', 'Cosmo City', 'Eldorado Park',
      'Dobsonville', 'Protea Glen'
    ],
    province: 'Gauteng'
  },
  'Ekurhuleni (East Rand)': {
    areas: [
      'Benoni', 'Boksburg', 'Kempton Park', 'Alberton', 'Germiston',
      'Springs', 'Brakpan', 'Nigel', 'Daveyton', 'Katlehong',
      'Vosloorus', 'Tembisa', 'Edenvale'
    ],
    province: 'Gauteng'
  },
  'Sedibeng / Vaal': {
    areas: [
      'Vereeniging', 'Vanderbijlpark', 'Meyerton', 'Sebokeng',
      'Sharpeville'
    ],
    province: 'Gauteng'
  },
  'Cape Town': {
    areas: [
      'Cape Town', 'Stellenbosch', 'Paarl', 'Bellville',
      'Somerset West', 'Strand', 'Kraaifontein', 'Milnerton',
      'Table View', 'Durbanville', 'Kuils River', 'Brackenfell',
      'Goodwood', 'Parow', 'Athlone', 'Mitchells Plain',
      'Khayelitsha', 'Gugulethu', 'Langa', 'Constantia',
      'Camps Bay', 'Sea Point', 'Green Point', 'Observatory',
      'Rondebosch', 'Claremont', 'Wynberg', 'Fish Hoek',
      'Simonstown', 'Hout Bay', 'Bloubergstrand', 'Melkbosstrand'
    ],
    province: 'Western Cape'
  },
  'Durban / eThekwini': {
    areas: [
      'Durban', 'Pietermaritzburg', 'Umhlanga', 'Ballito',
      'Pinetown', 'Phoenix', 'Chatsworth', 'Umlazi',
      'Verulam', 'Tongaat', 'Amanzimtoti', 'Westville',
      'Hillcrest', 'Kloof', 'Queensburgh', 'KwaMashu',
      'Ntuzuma', 'Inanda', 'Isipingo', 'Umkomaas'
    ],
    province: 'KwaZulu-Natal'
  },
  'Bloemfontein': {
    areas: ['Bloemfontein', 'Welkom', 'Botshabelo', 'Thaba Nchu', 'Virginia'],
    province: 'Free State'
  },
  'Port Elizabeth / Gqeberha': {
    areas: [
      'Port Elizabeth / Gqeberha', 'Uitenhage', 'Despatch', 'Motherwell',
      'KwaNobuhle'
    ],
    province: 'Eastern Cape'
  },
  'East London': {
    areas: [
      'East London', 'King Williams Town', 'Bhisho', 'Mdantsane',
      'Beacon Bay', 'Gonubie'
    ],
    province: 'Eastern Cape'
  },
  'George / Garden Route': {
    areas: ['George', 'Knysna', 'Mossel Bay', 'Plettenberg Bay', 'Oudtshoorn'],
    province: 'Western Cape'
  },
  'Polokwane': {
    areas: ['Polokwane', 'Seshego', 'Mankweng'],
    province: 'Limpopo'
  },
  'Nelspruit / Mbombela': {
    areas: [
      'Nelspruit / Mbombela', 'Witbank / Emalahleni', 'Witrivier',
      'Hazyview', 'Barberton'
    ],
    province: 'Mpumalanga'
  },
  'Rustenburg': {
    areas: ['Rustenburg', 'Brits', 'Hartbeespoort'],
    province: 'North West'
  },
  'Mahikeng': {
    areas: ['Mahikeng', 'Mmabatho', 'Lichtenburg'],
    province: 'North West'
  },
  'Potchefstroom': {
    areas: ['Potchefstroom', 'Klerksdorp', 'Orkney', 'Stilfontein'],
    province: 'North West'
  },
  'Kimberley': {
    areas: ['Kimberley', 'Upington', 'Kuruman'],
    province: 'Northern Cape'
  },
  'Limpopo North': {
    areas: ['Thohoyandou', 'Tzaneen', 'Louis Trichardt', 'Makhado', 'Giyani', 'Phalaborwa'],
    province: 'Limpopo'
  },
  'Mthatha': {
    areas: ['Mthatha', 'Butterworth', 'Lusikisiki'],
    province: 'Eastern Cape'
  }
};

// Derived flat array — backward compatible with existing SA_AREAS usage
export const SA_AREAS = [
  ...Object.values(CITY_AREAS).flatMap(city => city.areas).sort(),
  'Nationwide'
];

// Cross-proximity overrides for areas near multiple cities
const CROSS_PROXIMITY = {
  'midrand': ['pretoria', 'tshwane', 'centurion'],
  'centurion': ['johannesburg', 'midrand', 'sandton'],
  'sandton': ['centurion', 'midrand'],
  'hartbeespoort': ['pretoria', 'tshwane'],
  'randfontein': ['krugersdorp'],
};

// Auto-generate proximity map from CITY_AREAS
function buildProximityMap() {
  const map = {};
  for (const [cityName, cityData] of Object.entries(CITY_AREAS)) {
    const allAreas = cityData.areas;
    const province = cityData.province.toLowerCase();
    // Normalize city name into lowercased keys
    const cityKey = cityName.split('/')[0].trim().toLowerCase();
    for (const area of allAreas) {
      const key = area.toLowerCase();
      const neighbours = new Set(allAreas
        .filter(a => a.toLowerCase() !== key)
        .map(a => a.toLowerCase())
      );
      neighbours.add(cityKey);
      neighbours.add(province);
      map[key] = Array.from(neighbours);
    }
    // City name itself maps to all its areas + province
    map[cityKey] = [...allAreas.map(a => a.toLowerCase()), province];
  }
  // Apply cross-proximity overrides
  for (const [area, extras] of Object.entries(CROSS_PROXIMITY)) {
    if (map[area]) {
      extras.forEach(e => map[area].push(e.toLowerCase()));
    }
  }
  return map;
}

export const LOCATION_PROXIMITY = buildProximityMap();

// Given a search term, return all area names that should also match.
// Handles city names ("Pretoria" → all Pretoria suburbs),
// specific areas ("Ga-Rankuwa" → all Pretoria siblings),
// and proximity lookups.
export function expandLocationSearch(term) {
  const termLower = term.toLowerCase().trim();
  const results = new Set();

  // If term matches a province name, add all areas from all cities in that province
  for (const [, cityData] of Object.entries(CITY_AREAS)) {
    if (cityData.province.toLowerCase().includes(termLower) || termLower.includes(cityData.province.toLowerCase())) {
      cityData.areas.forEach(a => results.add(a.toLowerCase()));
      results.add(cityData.province.toLowerCase());
    }
  }

  // If term matches a city group name (or city key matches term)
  for (const [cityName, cityData] of Object.entries(CITY_AREAS)) {
    const cityKey = cityName.split('/')[0].trim().toLowerCase();
    if (cityKey.includes(termLower) || cityName.toLowerCase().includes(termLower) || termLower.includes(cityKey)) {
      cityData.areas.forEach(a => results.add(a.toLowerCase()));
      results.add(cityData.province.toLowerCase());
      results.add(cityKey);
    }
  }

  // If term matches a specific area, add its city + siblings
  for (const [cityName, cityData] of Object.entries(CITY_AREAS)) {
    for (const area of cityData.areas) {
      if (area.toLowerCase().includes(termLower)) {
        cityData.areas.forEach(a => results.add(a.toLowerCase()));
        results.add(cityData.province.toLowerCase());
        const cityKey = cityName.split('/')[0].trim().toLowerCase();
        results.add(cityKey);
        break;
      }
    }
  }

  // Also leverage auto-generated proximity map
  if (LOCATION_PROXIMITY[termLower]) {
    LOCATION_PROXIMITY[termLower].forEach(r => results.add(r.toLowerCase()));
  }

  return results;
}

// Get the parent city for a given area name
export function getCityForArea(areaName) {
  for (const [cityName, cityData] of Object.entries(CITY_AREAS)) {
    if (cityData.areas.some(a => a.toLowerCase() === areaName.toLowerCase())) return cityName;
  }
  return null;
}

// Get all areas belonging to a given city
export function getAreasForCity(cityName) {
  for (const [key, cityData] of Object.entries(CITY_AREAS)) {
    if (key.toLowerCase().includes(cityName.toLowerCase()) || cityName.toLowerCase().includes(key.split('/')[0].trim().toLowerCase())) {
      return cityData.areas;
    }
  }
  return [];
}

// Flattened array of all area names (excluding Nationwide)
export function getAllAreaNames() {
  return Object.values(CITY_AREAS).flatMap(c => c.areas);
}
